import { ILogger } from "./ILogger";

enum LogLevel {
  OFF = 0,
  FATAL = 1,
  ERROR = 2,
  WARN = 3,
  INFO = 4,
  DEBUG = 5,
  TRACE = 6,
  ALL = 7,
}

export class ConsoleLogger implements ILogger {
  private static _logLevel: LogLevel;
  
  static initialize(): void {
    // TODO: configure
    this._logLevel = LogLevel.ALL;
  }
/*  
  private static toLevel(source: string): LogLevel {
    switch (source.toUpperCase()) {
      case "ALL": return LogLevel.ALL;
      case "TRACE": return LogLevel.TRACE;
      case "DEBUG": return LogLevel.DEBUG;
      case "INFO": return LogLevel.INFO;
      case "WARN": return LogLevel.WARN;
      case "ERROR": return LogLevel.ERROR;
      case "FATAL": return LogLevel.FATAL;
      case "OFF": return LogLevel.OFF;
      default: return LogLevel.INFO;
    }
  }
*/
  private static toLevelText(level: LogLevel): string {
    switch (level) {
      case LogLevel.ALL: return "ALL";
      case LogLevel.TRACE: return "TRACE";
      case LogLevel.DEBUG: return "DEBUG";
      case LogLevel.INFO: return "INFO";
      case LogLevel.WARN: return "WARN";
      case LogLevel.ERROR: return "ERROR";
      case LogLevel.FATAL: return "FATAL";
      case LogLevel.OFF: return "OFF";
      default: return "UNKNOWN";
    }
  }
  
  trace(...messages: any[]): void {
    ConsoleLogger.putLog(LogLevel.TRACE, messages, console.trace);
  }

  debug(...messages: any[]): void {
    ConsoleLogger.putLog(LogLevel.DEBUG, messages, console.debug);
  }

  info(...messages: any[]): void {
    ConsoleLogger.putLog(LogLevel.INFO, messages, console.info);
  }

  warn(...messages: any[]): void {
    ConsoleLogger.putLog(LogLevel.WARN, messages, console.warn);
  }

  error(...messages: any[]): void {
    ConsoleLogger.putLog(LogLevel.ERROR, messages, console.error);
  }

  fatal(...messages: any[]): void {
    ConsoleLogger.putLog(LogLevel.FATAL, messages, console.error);
  }

  private static putLog(level: LogLevel, messages: any[], log: (message: any) => void): void {
    try {
      if (ConsoleLogger._logLevel < level) { return; }
      const prefix = ConsoleLogger.createPrefix(level);
      if (messages && messages.length) {
        for (const message of messages) {
          log(prefix + message);
        }
      } else {
        log(prefix + messages);
      }
    } catch (e) {
      console.error(e);
    }
  }

  private static createPrefix(level: LogLevel): string {
    const date = new Date();
    return this.fill(date.getHours(), 2) + ":" +
      this.fill(date.getMinutes(), 2) + ":" +
      this.fill(date.getSeconds(), 2) + "." +
      this.fill(date.getMilliseconds(), 3) + ":[" + ConsoleLogger.toLevelText(level) + "] ";
  }

  /**
   * 先頭の0埋め。3桁までしか対応していません
   */
  private static fill(value: number, length: number): string {
    const text = value.toString();
    if (text.length >= length) { return text; }
    return ("000" + text).substr(0, length);
  }
}
